import { Component, Input, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { UiService } from '../../../services/core.ui.service';
import { GfTitleService } from '../../../services/core.title.service';
import { UserService } from '../../../services/core.user.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';

@Component({
  selector: 'change-password',
  template: require('./changepassword.component.html')
})
export class ChangePasswordComponent implements OnInit {
  @Input() user: any;
  @Input() siteConfig: any;

  currentPassword: string = 'wrongo';
  newPassword1: string = 'password123';
  newPassword2: string = 'password123';
  changingPassword: boolean = false;

  passwordRulesDesc: string | boolean = false;

  missingCurrentPassword: boolean = false;
  missingNewPassword: boolean = false;
  mismatchedPassword: boolean = false;

  constructor(
    private http: HttpClient,
    private stateService: StateService, 
    
    private uiService: UiService,
    private userService: UserService,
    private translateService: GfTranslateService,
    private titleService: GfTitleService
  ) {}

  get isOidc(): boolean {
    return this.userService.session.getAuthMethod() === 'oidc';
  }

  ngOnInit(): void {
    this.titleService.setTitle('Change Password');

    if (!this.userService.session.hasUser()) {
      this.stateService.go('home.user.login');
      return;
    }

    this.user = this.userService.session.getUser();
    this.passwordRulesDesc = _.get(this, 'siteConfig.passwordRulesDesc', false);
  }

  postChangePassword(): void {
    if (!this.validateForm()) return;

    this.changingPassword = true;
    const unixName = this.userService.session.getUnixName();

    this.changePassword(unixName, this.isOidc ? null : this.currentPassword, this.newPassword1)
      .then(
        (result) => { this.handleChangePasswordResult(result) },
        (err) => { this.showFailure(err) }
      )
      .catch(() => {
        this.changingPassword = false;
      });
  }

  private validateForm(): boolean {
    this.missingCurrentPassword = !this.isOidc && !this.currentPassword;
    this.missingNewPassword = !this.newPassword1;
    this.mismatchedPassword = this.newPassword1 !== this.newPassword2;

    return !this.missingCurrentPassword && !this.missingNewPassword && !this.mismatchedPassword;
  }

  private changePassword(unixName: string, oldPassword: string, newPassword: string): Promise<any> {
    return this.http
      .post(`/api/user/${unixName}/password`, {
        oldPassword: oldPassword,
        password: newPassword
      }, { observe: 'response' }) // Request the full response
      .toPromise()
      .then((response: HttpResponse<any>) => {
        return {status: response.status}; // Return the status
      })
      .catch((error) => {
        throw {status: error.status}; // Propagate the error status
      });
  }

  private handleChangePasswordResult(response: any): void {
    const msgTitle = this.translateService.translate('Change Password');
    const msgSuccess = this.translateService.translate('Your password was changed');

    const status = _.get(response, 'status', 0);

    if ([200, 201].includes(status)) {
      this.uiService.message.showSuccess(msgSuccess, msgTitle);
      this.stateService.go('home.user.userhome', { unixName: this.userService.session.getUnixName() });
    }
  }

  private showFailure(response: any): void {
    const status = _.get(response, 'status', 0);
    if (status === 404) {
      const msgInvalid = this.translateService.translate('Sorry, your current password was not entered correctly');
      this.uiService.message.showError(msgInvalid, this.translateService.translate('Change Password'));
    } else if (status === 400) {
      const reason = Array.isArray(response) ? _.get([0], 'password', null) : null;
      if (reason?.type === 'recent') {
        const msgRecent = this.translateService.translate('Recently used password');
        this.uiService.message.showError(
          this.translateService.translate('Password was recently used, please enter a different one'),
          msgRecent
        );
      } else {
        let msg = this.translateService.translate('Password reset failed');
        if (response.password?.some((err: any) => err.type === 'regex')) {
          msg += '. ' + this.translateService.translate('The password you entered does not comply with the required format.');
        }
        this.uiService.message.showError(msg, this.translateService.translate('Error'));
      }
    } else {
      this.uiService.message.showError(
        this.translateService.translate('Your new password does not comply with the required format'),
        this.translateService.translate('Change Password')
      );
    }
  }
}
